import { Button } from 'antd'; //TODO only use the config provider once in the main app
import { useAuth } from '../utils/AuthContext';
import './LoginForm.css';
import { useLanguage } from '../utils/LanguageContext';
import translations from '../components/ComponentsTranslations.lang.json';
import { loginUserSchema } from '../shared/validations/userValidations';
import { FormInput, FormSubmit, ValidatedForm } from './common/ValidatedForm';
import { Link } from 'react-router-dom';

const LoginForm = () => {
  const { lang } = useLanguage(translations);
  const { logInWithEmailAndPassword, logInWithGoogle } = useAuth();

  return (
    <div>
      <Button onClick={logInWithGoogle}>{lang('loginWithGoogle')}</Button>

      <ValidatedForm key="loginForm" schema={loginUserSchema} handleSubmit={logInWithEmailAndPassword}>
        <FormInput name="email" type="email" />
        <FormInput name="password" type="password" />
        <FormSubmit>{lang('login')}</FormSubmit>
      </ValidatedForm>

      <Link to="/forgotPassword">{lang('forgotPassword')}</Link>
    </div>
  );
};

export default LoginForm;
